/**
 * Range provides a common Numeric Range API.
 */
export class Range {

    /**
     * Check if a number is in range.
     */
    public static isInRange(n: number, min: number, max: number, blacklist: any[] = null): boolean {
        if (!blacklist) {
            blacklist = new Array();
        }

        if (blacklist.length > 0) {
            for (let i in blacklist)
                if (n == blacklist[i]) {
                    return false;
                }
        }
        return (n >= min && n <= max);
    }

    /**
     * Returns a set of random numbers inside a specific range (unique numbers is optional)
     */
    public static randRangeSet(min: number, max: number, count: number, unique: boolean): any[] {
        let rnds: any[] = new Array();

        if (unique && count <= max - min + 1) {
            //unique - create num range array
            let nums: any[] = new Array();

            for (let i: number = min; i <= max; i++) {
                nums.push(i);
            }

            for (let j: number = 1; j <= count; j++) {
                // random number
                let rn: number = Math.floor(Math.random() * nums.length);
                rnds.push(nums[rn]);
                nums.splice(rn, 1);
            }
        }
        else {
            //non unique
            for (let k: number = 1; k <= count; k++) {
                rnds.push(Range.randRangeInt(min, max));
            }
        }
        return rnds;
    }

    /**
     * Returns a random float number within a given range
     */
    public static randRangeFloat(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }

    /**
     * Returns a random int number within a given range
     */
    public static randRangeInt(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    /**
     * Resolve the number inside the range. If outside the range the nearest boundary value will be returned.
     */
    public static resolve(val: number, min: number, max: number): number {
        return Math.max(Math.min(val, max), min);
    }

    /**
     * Locate and return the middle value between the three.
     */
    public static center(a: number, b: number, c: number): number {
        if ((a > b) && (a > c)) {
            if (b > c) {
                return b;
            }
            else {
                return c;
            }
        }
        else if ((b > a) && (b > c)) {
            if (a > c) {
                return a;
            }
            else {
                return c;
            }
        }
        else if (a > b) {
            return a;
        }
        else {
            return b;
        }
    }

    /**
     * Range Static Constructor
     */
    constructor() {
        throw new Error("Range is a static class and cannot be instantiated.");
    }
}
